<template>
  <div class="container-spin p-6 md:px-12 xl:py-10 xl:px-40" :class="isMobile ? 'bg-mobile__v3' : 'bg-web__v3'">
    <div class="w-full flex justify-end">
      <el-button v-if="logged" class="bg-[#FFD602] text-black" @click="logout">Đăng xuất</el-button>
      <el-button v-else class="bg-[#FFD602] text-black" @click="login">Đăng nhập</el-button>
    </div>
    <HeaderSpin/>
    <div class="flex flex-col items-center mb-10 xl:px-28">
      <CarouselSpin ref="carouselRef" />
      <button
          @click="startSpin"
          :disabled="disabledSpin"
          class="btn-hex-2 relative text-black font-semibold text-sm px-8 py-3 bg-[#FFD602] hover:bg-[#ffcc00]  transition-all mt-8 md:text-[24px] md:px-16 md:py-6"
      >
        Quay Ngay
      </button>
    </div>
    <div class="w-full flex flex-col justify-center items-center">
      <span class="text-white text-[18px] xl:text-[32px] italic font-bold">Quay liền tay - Trúng quà ngay</span>
      <span class="text-white text-[13px] mb-5 xl:text-[24px] italic">Thời gian quay thưởng: <span class="text-[#FFD602]">Từ 26/11/2025 đến 30/11/2025</span></span>
      <span class="text-white text-[13px] xl:text-[24px]">Đối tượng áp dụng: Khách hàng đăng ký học chương trình</span>
      <span class="text-white text-[18px] xl:text-[32px] text-center mb-5 font-bold"><span class="text-[#FFD602]">"CUỐI THÁNG SALE TO - HỌC IELTS CHẲNG LO"</span> thành công</span>
      <div class="bg-[#FFD602] py-2 px-4 rounded-xl w-full flex flex-col justify-center gap-1 md:items-center md:flex-row mb-5">
        <el-button @click="isAll = true" class="w-full rounded-full md:text-[20px]" :class="isAll ? 'bg-[#0E0E0E] text-[#FFD602]' : 'bg-[#0E0E0EB2] text-white'">Tất cả người chơi</el-button>
        <el-button @click="isAll = false" class="w-full rounded-full ml-0 md:text-[20px]" :class="isAll ? 'bg-[#0E0E0EB2] text-white' : 'bg-[#0E0E0E] text-[#FFD602]'">Quà tặng của tôi</el-button>
      </div>
      <TableMobile v-if="isMobile" :rewards="gifts" :loading="loading"/>
      <TableDesktop v-else :rewards="gifts" :loading="loading"/>
      <div class="edu-paginate mx-auto text-center mt-10 mb-5">
        <el-pagination
            background
            hide-on-single-page
            layout="prev, pager, next"
            :current-page="page"
            :total="total"
            @current-change="changePage">
        </el-pagination>
      </div>
    </div>
    <div class="text-white mt-5 xl:text-[16px] xl:flex xl:gap-16">
      <AwardComponent />
      <Note />
    </div>
    <el-dialog
        title="Đăng nhập" center
        :visible.sync="isLogin"
        :width="isMobile ? '90%' : isTablet ? '50%' : '30%'"
        :before-close="handleCloseLogin">
      <div>
        <div class="dialog-input" style="line-height: 30px;">
          <div>
            <div class="col-xxl-3 col-md-4">
              <label>
                <b>Số điện thoại</b><span class="ml-2" style="color:red">*</span>
              </label>
              <div class="form-group w-100">
                <el-input
                    class="shadow-sm" type="text" v-model="query.phone"
                    clearable placeholder="Nhập số điện thoại" @input="debounceCheckPhone"
                />
              </div>
              <p v-if="query.phone === '' && checkValidate" class="text-red-500 break-words">Số điện thoại không được để trống</p>
              <p v-if="errorPhone" class="text-red-500 break-words">Số điện thoại chưa được đăng ký quay thưởng. Vui lòng liên hệ tư
                vấn viên để được hỗ trợ đăng ký.</p>
            </div>
          </div>
          <div class="col-xxl-3 col-md-4">
            <label class="mb-2">
              <b>Họ và tên</b>
            </label>
            <div class="form-group w-100" id="id-name">
              <el-input
                  :disabled="true" class="shadow-sm !text-black" type="text"
                  v-model="query.name" clearable placeholder="Nhập họ và tên"
              ></el-input>
            </div>
            <p v-if="query.name === '' && checkValidate" style="color: red">Họ và tên không được để trống</p>
          </div>
        </div>
        <div class="dialog-footer text-center mt-5">
          <el-button :disabled="disabledSubmit" @click="handleLogin">Đăng nhập</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        title="Thông báo" v-if="isShowAlreadySpunDialog"
        :visible.sync="isShowAlreadySpunDialog"
        :width="isMobile ? '90%' : isTablet ? '50%' : '30%'"
        center :show-close="false">
      <div class="text-center py-4">
        <p class="text-lg">Bạn đã quay thưởng rồi</p>
      </div>
      <div slot="footer" class="dialog-footer text-center">
        <el-button type="primary" @click="isShowAlreadySpunDialog = false">Đóng</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="Chúc mừng bạn đã trúng thưởng"
        :visible.sync="isNotification" v-if="isNotification"
        :width="isMobile ? '90%' : isTablet ? '50%' : '30%'"
    >
      <div class="flex justify-center flex-col items-center">
        <span class="block text-center text-[16px] xl:text-[20px] font-bold mb-6">{{ giftName }}</span>
        <img class="h-auto object-contain" :class="isMobile ? 'w-[80%]' : isTablet ? 'w-[45%]' : 'w-[26%]'" :src="imageUrl" alt="gift-image"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HeaderSpin from "@/pages/version3/components/Header.vue";
import AwardComponent from "@/pages/version3/components/Award.vue";
import Note from "@/pages/version3/components/Note.vue";
import TableMobile from "@/pages/version3/components/TableMobile.vue";
import moment from "moment/moment";
import _ from "lodash";
import {
  CHECK_PHONE_USER,
  GET_GIFT,
  GET_HISTORY_GIFT,
  GET_MY_GIFT,
  GET_NAME_USER,
  INFORMATION_SPIN
} from "@/common/apiUrl";
import TableDesktop from "@/pages/version3/components/TableDesktop.vue";
import CarouselSpin from "@/pages/version3/components/Carousel.vue";

export default {
  name: 'SpinCarousel',
  components: {CarouselSpin, TableDesktop, TableMobile, Note, AwardComponent, HeaderSpin },
  data() {
    return {
      isMobile: window.innerWidth < 767,
      isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
      gifts: [],
      isAll: true,
      isLogin: false,
      isShowAlreadySpunDialog: false,
      loading: false,
      giftName: null,
      query: {
        phone: '',
        name: '',
      },
      disabledSubmit: true,
      checkValidate: false,
      errorPhone: false,
      URL_API_EDUTALK: process.env.VUE_APP_API_URL,
      imageUrl: '',
      disabled: true,
      dataHistory: [],
      dataGift: [],
      isNotification: false,
      disabledSpin: true,
      page: 1,
      total: 0,
      lastPage: 1,
    }
  },
  watch: {
    isAll: {
      handler(newVal) {
        if (newVal) {
          this.getHistoryGift().then(() => {
            this.updateGiftsData();
          });
        } else {
          this.getMyGift().then(() => {
            this.updateGiftsData();
          });
        }
      },
      immediate: false
    },
    dataGift: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          const latestGift = newVal.reduce((prev, current) => {
            return moment(current.time, 'HH:mm DD-MM-YYYY').isAfter(moment(prev.time, 'HH:mm DD-MM-YYYY')) ? current : prev;
          });
          
          if (latestGift.gift_id) {
            setTimeout(() => {
              if (this.$refs.carouselRef && this.$refs.carouselRef.setWinningGiftInCenter) {
                this.$refs.carouselRef.setWinningGiftInCenter(latestGift.gift_id);
              }
            }, 100);
          }
        }
      },
      deep: true
    }
  },
  async mounted() {
    await this.getHistoryGift()
    await this.getMyGift()
    this.updateGiftsData()
    if (this.dataGift && this.dataGift.length > 0) {
      setTimeout(() => {
        if (this.$refs.carouselRef && this.$refs.carouselRef.setWinningGiftInCenter) {
          const latestGift = this.dataGift.reduce((prev, current) => {
            return moment(current.time, 'HH:mm DD-MM-YYYY').isAfter(moment(prev.time, 'HH:mm DD-MM-YYYY')) ? current : prev;
          });
          if (latestGift.gift_id) {
            this.$refs.carouselRef.setWinningGiftInCenter(latestGift.gift_id);
          }
        }
      }, 100);
    }
    
    const res_time_program = await fetch(`${this.URL_API_EDUTALK}/${INFORMATION_SPIN}`);
    const data_time_program = await res_time_program.json();
    if (data_time_program.data.id) {
      this.idProgram = data_time_program.data.id
      this.disabledSpin = false
    }
  },
  computed: {
    logged() {
      return localStorage.phone && localStorage.name
    }
  },
  methods: {
    login() {
      this.isLogin = true
    },
    changePage(page) {
      this.page = page
      this.getHistoryGift()
    },
    handleLogin() {
      if (this.query.phone === '' || this.errorPhone) {
        this.checkValidate = true
        return
      }
      localStorage.setItem('name', this.query.name)
      localStorage.setItem('phone', this.query.phone)
      this.$message.success('Đăng nhập thành công!')
      setTimeout(() => {
        location.reload();
      },0)
    },
    logout() {
      localStorage.clear();
      location.reload();
    },
    handleCloseLogin() {
      this.isLogin = false
      this.query.phone = ''
      this.query.name = ''
    },
    async startSpin() {
      if (!this.logged) {
        this.isLogin = true;
        return;
      }
      this.disabledSpin = true
      if (this.dataGift && this.dataGift.length > 0) {
        this.isShowAlreadySpunDialog = true;
        return;
      }
      const phone = localStorage.phone ?? '';
      if (this.logged) {
        this.imageUrl = '';
        let form = new FormData();
        form.append('phone', phone);
        form.append('spin_reward_program_id', this.idProgram);

        try {
          const response = await fetch(`${this.URL_API_EDUTALK}/${GET_GIFT}`, {
            method: "POST",
            body: form,
          });
          const gift = await response.json();
          let winningGiftId = gift?.data?.gift_id ?? -1;
          if (winningGiftId !== -1) {
            await this.$refs.carouselRef.startSpin(winningGiftId);
          }
          this.isNotification = true
          this.imageUrl = gift?.data?.url ?? '';
          this.giftName = gift?.data?.name ?? ''
          await this.getMyGift();
        } catch (error) {
          console.error('Lỗi khi quay thưởng:', error);
        } finally {
          this.disabled = false;
          this.disabledSpin = false
        }
      }
    },
    async CheckPhone() {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(async () => {
        const response = await fetch(`${this.URL_API_EDUTALK}/${CHECK_PHONE_USER}?phone=${this.query.phone}`);
        let data = await response.json();
        this.errorPhone = data.error
        if (!data.error) {
          const res = await fetch(`${this.URL_API_EDUTALK}/${GET_NAME_USER}?phone=${this.query.phone}`);
          const response = await res.json();
          if (!response.error) {
            this.query.name = response.data?.name
            this.disabledSubmit = false
          } else {
            this.$notify({
              title: 'Cảnh báo',
              message: response.message,
              type: 'warning',
              offset: 100
            });
          }
        } else {
          this.$notify({
            title: 'Cảnh báo',
            message: data.message,
            type: 'warning',
            offset: 100
          });
        }
      }, 800);

    },
    async getHistoryGift() {
      this.gifts = []
      this.loading = true
      try {
        const response = await fetch(`${this.URL_API_EDUTALK}/${GET_HISTORY_GIFT}?page=${this.page}`);
        let data = await response.json();
        this.page = data.data.current_page
        this.lastPage = data.data.last_page
        this.total = data.data.total
        this.dataHistory = data?.data?.data?.map((informationGift) => {
          return {
            id: informationGift?.id,
            name: informationGift?.name,
            phone: '*******' + informationGift?.phone.slice(7, 10),
            prize: informationGift?.spin_gift?.name,
            time: moment(informationGift?.time).format('HH:mm DD-MM-YYYY')
          }
        })
        this.updateGiftsData()
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    async getMyGift() {
      this.loading = true
      try {
        if (!localStorage.getItem('phone')) return;
        const response = await fetch(`${this.URL_API_EDUTALK}/${GET_MY_GIFT}?phone=${localStorage.getItem('phone')}`);
        let data = await response.json();
        this.dataGift = data?.data?.data?.map((informationGift) => {
          return {
            id: informationGift.id,
            name: localStorage.getItem('name') || '',
            phone: localStorage.getItem('phone') ? localStorage.getItem('phone') : '',
            prize: informationGift?.spin_gift?.name,
            time: moment(informationGift?.time).format('HH:mm DD-MM-YYYY'),
            gift_id: informationGift?.spin_gift?.id
          }
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    updateGiftsData() {
      if (this.isAll) {
        this.gifts = this.dataHistory || [];
      } else {
        this.gifts = this.dataGift || [];
      }
    },
    debounceCheckPhone: _.debounce(function () {
      this.CheckPhone()
    }, 500),
  }
}
</script>

<style>
.el-pagination.is-background .el-pager li.active {
  background-color: #FFD602 !important;
  color: #000 !important;
}
.btn-hex-2 {
  position: relative;
  background: #ffd602;
  border: none;
  color: black;
  clip-path: polygon(10% 0%, 90% 0%, 100% 50%, 90% 100%, 10% 100%, 0% 50%);
}
.btn-hex-2::before {
  content: "";
  position: absolute;
  inset: 0;
  background: inherit;
  z-index: -1;
  filter: drop-shadow(0 0 6px rgba(255, 214, 2, 0.6));
  clip-path: inherit;
}
#id-name .el-input__inner {
  color: black !important;
}
</style>